module.exports = __webpack_public_path__ + "static/media/visa.fb09d128.svg";